import { string } from "yup";
import { removeTrailingPunctuation, WEBSITE_URL_REGEX } from "@shared-kernel/primary/shared/url-input/url-input.helpers";

export const websiteUrlInvalidMessage = (example = "monsite.fr") => `Adresse non reconnue. Exemple : ${example}`;

// The rule of every free-text website field, typed through `UrlInput`.
export const websiteUrlValidation = (example?: string) => {
  const message = websiteUrlInvalidMessage(example);
  return string().transform(removeTrailingPunctuation).url(message).matches(WEBSITE_URL_REGEX, { message, excludeEmptyString: true });
};
